/* eslint-disable sort-keys */
import { CFTokens } from '../../../../tokens';
export const BACKGROUND_COLOR = {
    DEFAULT: CFTokens.COLOR.BACKGROUND_DEFAULT,
    DISABLED: CFTokens.COLOR.INTERACTIVE_DISABLED,
};
export const BORDER_COLOR = {
    DEFAULT: CFTokens.COLOR.BORDER_DEFAULT,
    DISABLED: CFTokens.COLOR.TRANSPARENT,
    FOCUSED: CFTokens.COLOR.BORDER_STRONG,
    SUCCESS: CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
    ERROR: CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
};
export const BORDER_RADIUS = CFTokens.BORDER_RADIUS.A;
export const BORDER_WIDTH = {
    DEFAULT: CFTokens.BORDER_SIZE.THIN,
    FOCUSED: CFTokens.BORDER_SIZE.MEDIUM,
};
export const ROOT_GAP = {
    sm: CFTokens.SPACER.B,
    md: CFTokens.SPACER.B,
    lg: CFTokens.SPACER.C,
    xl: CFTokens.SPACER.B,
};
export const ROOT_HEIGHT = {
    sm: 36,
    md: 40,
    lg: 48,
    xl: 56,
};
export const ROOT_PADDING_LEFT = {
    sm: 8,
    md: 8,
    lg: 12,
    xl: 16,
};
export const ROOT_PADDING_RIGHT = {
    sm: 8,
    md: 12,
    lg: 16,
    xl: 16,
};
export const ROOT_PADDING_VERTICAL = {
    sm: 4,
    md: 8,
    lg: 8,
    xl: 8,
};
